import { useTranslations } from "use-intl";

interface ReservationNextStepsProps {
  type: "flight" | "hotel";
}

export const ReservationNextSteps = ({ type }: ReservationNextStepsProps) => {
  const t = useTranslations();
  const showFlightInfo = type === "flight";
  const showHotelInfo = type === "hotel";

  return (
    <section className="mt-4">
      <h3 className="section-title">{t("reservations.whatsNext")}</h3>
      <div className="section-card flex flex-col gap-2 text-sm">
        {showFlightInfo ? (
          <p>{t("reservations.flight.whatsNextDescription")}</p>
        ) : null}
        {showHotelInfo ? (
          <p>{t("reservations.hotel.whatsNextDescription")}</p>
        ) : null}
      </div>
    </section>
  );
};
